import actions from './actions';


const { 
    MINING_DASHBOARD_DATA_BEGIN, MINING_DASHBOARD_DATA_SUCCESS, MINING_DASHBOARD_DATA_ERR,
    MINING_CATEGORY_LIST_BEGIN, MINING_CATEGORY_LIST_SUCCESS, MINING_CATEGORY_LIST_ERR,
    MINING_REASON_LIST_BEGIN, MINING_REASON_LIST_SUCCESS, MINING_REASON_LIST_ERR,
    MINING_LEADS_BEGIN, MINING_LEADS_SUCCESS, MINING_LEADS_ERR,
    MINING_DATA_BEGIN, MINING_DATA_SUCCESS, MINING_DATA_ERR,  MINING_DATA_RESET,
    MINING_PUSH_LEADS_BEGIN,MINING_PUSH_LEADS_SUCCESS,MINING_PUSH_LEADS_ERR
} = actions;

const initialStateArray = { data: [], loading: false, error: null, };

// Mining Information Data Reducers
export const miningDashboardDataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case MINING_DASHBOARD_DATA_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case MINING_DASHBOARD_DATA_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case MINING_DASHBOARD_DATA_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };

        default:
            return state;
    }
};

export const miningCategoryListReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case MINING_CATEGORY_LIST_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case MINING_CATEGORY_LIST_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case MINING_CATEGORY_LIST_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };

        default:
            return state;
    }
};

export const miningReasonListReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case MINING_REASON_LIST_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case MINING_REASON_LIST_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case MINING_REASON_LIST_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };

        default:
            return state;
    }
};

export const miningLeadsReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case MINING_LEADS_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case MINING_LEADS_SUCCESS:            
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case MINING_LEADS_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };

        default:
            return state;
    }
};

export const submitMiningReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case MINING_DATA_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case MINING_DATA_SUCCESS:            
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case MINING_DATA_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };
        case MINING_DATA_RESET:
            return initialStateArray;
                
        default:
            return state;
    }
};

export const MiningPushLeadsReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case MINING_PUSH_LEADS_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case MINING_PUSH_LEADS_SUCCESS:            
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case MINING_PUSH_LEADS_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };

        default:
            return state;
    }
};